import { render, staticRenderFns } from "./CardService.vue?vue&type=template&id=2b12c0e8&scoped=true&"
import script from "./CardService.vue?vue&type=script&lang=ts&"
export * from "./CardService.vue?vue&type=script&lang=ts&"
import style0 from "./CardService.vue?vue&type=style&index=0&id=2b12c0e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b12c0e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VIcon,VImg,VRow})
